import { ClickAwayListener, Popper, useMediaQuery } from "@mui/material";
import { memo, useEffect, useMemo, useState } from "react";
import { isMobile } from "react-device-detect";
import { connect, useDispatch } from "react-redux";
import { compose } from "redux";

import { setSimpleValue } from "@/store/actions";

import { getSimpleValue } from "../../../store/selectors";
import VoiceMemoPlayback from "../../components/VoiceMemo/VoiceMemoPlayback";

// interface VoiceMemoPlaybackPopperProps {
//   anchor: proptypes.object,
//   open: proptypes.bool,
//   positioning: proptypes.string,
//   url: proptypes.string,
// };

function VoiceMemoPlaybackPopper(props) {
  const { anchor, open, positioning, url } = props;
  //force destroy and recreate the audio element (voiceMemoPlayback) when the url changes
  const [key, setKey] = useState(0);
  const dispatch = useDispatch();
  const smallElements = useMediaQuery(`(max-width:720px)`);

  const placement = smallElements || positioning === "content" ? "bottom" : "bottom-end";

  useEffect(() => {
    setKey((prev) => prev + 1);
  }, [url]);

  const styles = useMemo(
    () => ({
      zIndex: 3000,
      width: "300px",
      display: "inline-flex",
      color: "white",
      alignItems: "center",
    }),
    [],
  );

  const modifiers = useMemo(
    () => [
      {
        name: "offset",
        options: {
          offset: [0, 16],
        },
      },
    ],
    [],
  );

  const handleClose = () => {
    isMobile && dispatch(setSimpleValue("voice-memo-playback", { open: false }));
  };

  if (!anchor || !open || !url) {
    // no reason to render
    return null;
  }

  return (
    <Popper
      anchorEl={anchor}
      open={open}
      placement={placement}
      sx={styles}
      modifiers={modifiers}
      disablePortal={!isMobile}
    >
      <ClickAwayListener onClickAway={handleClose}>
        <div style={{ width: "100%" }}>
          <VoiceMemoPlayback url={url} style={{ width: "100%" }} key={key} />
        </div>
      </ClickAwayListener>
    </Popper>
  );
}

function mapStateToProps(state) {
  const { open, anchor, element } = getSimpleValue(state, "voice-memo-playback", {});

  return {
    open,
    anchor,
    positioning: element?.positioning,
    url: element?.url,
  };
}

export default compose(connect(mapStateToProps), memo)(VoiceMemoPlaybackPopper);
